import { AUTHORITATIVE_PASSAGE } from "../../shared/authoritativePassage";
import type { PassageParagraph } from "../types";

// 保留界面的 section 字段，同时保证正文只来自客户端与服务端共用的权威目录。
export const passage: readonly PassageParagraph[] = AUTHORITATIVE_PASSAGE.map((paragraph) => ({
  id: paragraph.id,
  section: paragraph.chapterId,
  text: paragraph.text
}));

// 按编号获取课文段落，未命中时返回空文本，避免界面崩溃。
export function getParagraph(id: string): PassageParagraph | undefined {
  return passage.find((paragraph) => paragraph.id === id);
}
